import BaseObject from "@base/baseObject.js";

/**
 * Gear item entity. Mirrors the backend's legacy overview shape (flattened
 * en_/de_ content, accessType = visibility, `image` naming the title image and
 * `images` listing every linked file).
 */
export default class ShowcaseObject extends BaseObject {
  static fields = [
    { key: "en_title", type: "text", section: "en", editable: true },
    { key: "en_content", type: "textarea", section: "en", editable: true },
    { key: "en_detail", type: "richtext", section: "en", editable: true },
    { key: "de_title", type: "text", section: "de", editable: true },
    { key: "de_content", type: "textarea", section: "de", editable: true },
    { key: "de_detail", type: "richtext", section: "de", editable: true },
    { key: "accessType", type: "visibility", section: "meta", editable: true },
    { key: "image", type: "text", section: "meta", editable: false },
  ];

  title(lang) {
    return this[`${lang}_title`] || this.en_title || this.de_title || "";
  }

  /** Short blurb — the diptych's text panel. */
  content(lang) {
    return this[`${lang}_content`] || "";
  }

  /**
   * Long-form write-up as sanitized HTML, for the detail page below the
   * diptych. Render it through richText.js, never by interpolation.
   */
  detail(lang) {
    return this[`${lang}_detail`] || "";
  }

  /** Every linked image's filename, in the order the backend listed them. */
  imageNames() {
    return (this.images || []).map((i) => i.name);
  }

  /**
   * The image standing in for this item (pile tile, diptych panel). Falls back
   * to the first linked image, so an item with photos is never shown blank just
   * because nobody picked a cover.
   */
  titleImage() {
    return this.image || this.imageNames()[0] || null;
  }

  isPublic() {
    return this.accessType === 1;
  }

  isDraft() {
    return this.accessType === 2;
  }
}
